import { useState, useContext } from "react";
import axios from "axios";
import { GlobalContext } from "../../Context/GlobalContext";

function useOrder() {

  const { baseUrl, userID, basicAuth } = useContext(GlobalContext);

  const headers = {
    headers: {
      Authorization: basicAuth,
      "Content-Type": "application/json",
    },
  };

  const [deliveryType, setDeliveryType] = useState("");
  const [loading, setLoading] = useState(false);

  /* ==============================
        GET DELIVERY PARTNER
  ============================== */

  const getDeliveryType = async () => {
    try {
      setLoading(true);

      const requestBody = {
        userid: userID,
        secret: "string",
      };

      const response = await axios.post(
        `${baseUrl}/Order/getDeliveryProvider`,
        requestBody,
    headers
      );

      if (response.data.responseCode === "00") {
        setDeliveryType(response.data.response.deliveryPartner);
      }

      return response.data;

    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  /* ==============================
        UPDATE DELIVERY PARTNER
  ============================== */

  const selectDeliveryPartner = async (partnerType) => {
    try {

      const requestBody = {
        userid: userID,
        deliveryPartner: partnerType,
        secret: "string",
      };

      const response = await axios.post(
        `${baseUrl}/Order/updateDeliveryProvider`,
        requestBody,
      headers
      );

      if (response.data.responseCode === "00") {
        setDeliveryType(partnerType);
      }

      return response.data;

    } catch (error) {
      console.log("Error updating delivery partner.");
    }
  };

  return {
    deliveryType,
    loading,
    getDeliveryType,
    selectDeliveryPartner,
  };
}

export default useOrder;